import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {StorageService} from './core/services/helpers/storage.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "appFirmaFront";
  isIframe = false;
  loginDisplay = false;
  showNotification = false;
  menuDinamic: any = [];
  clock: Observable<Date>;
  hour: string = "";
  startHour: string = "07:00:00";
  endHour: string = "20:00:00";
  alertHour: string = "19:45:00";
  pipe = new DatePipe("en-US");
  titleError: string;
  descriptionError: string;
  textButtonRight: string;
  unerror: boolean;
  errorsShow: any[] = [];
  closeSesion: boolean = false;

    constructor(
                private router: Router
            ) {
    }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    if (currentUrl === '/' || currentUrl.startsWith('/home')) {
      localStorage.clear();
    }
  }
}
